import { createEmitter } from './../../..';
export var createNavBlocker = function () {
    var blockedEmitted = createEmitter();
    var emitter = createEmitter();
    var blockReleaser = function (_) {
        //
    };
    var isBlocked = function () { return emitter.getLast() || false; };
    return {
        block: function () {
            if (isBlocked()) {
                throw new Error('Navigation is already blocked.');
            }
            else {
                emitter.publish(true);
            }
        },
        unblock: function () {
            if (!isBlocked()) {
                throw new Error('Navigation is already unblocked.');
            }
            else {
                emitter.publish(false);
            }
        },
        reportBlocked: function () {
            blockedEmitted.publish({});
        },
        releaseBlock: function () {
            blockReleaser(true);
        },
        setBlockReleaser: function (cb) { return blockReleaser = cb; },
        onBlocked: blockedEmitted.addListener,
        addListener: emitter.addListener,
        isBlocked: isBlocked
    };
};
//# sourceMappingURL=index.js.map